import { Component, OnInit,AfterViewInit, ElementRef, ViewChild,ViewChildren, NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,EventEmitter, QueryList} from '@angular/core';
import {BrowserModule, DomSanitizer, Title, SafeResourceUrl} from '@angular/platform-browser'
import { ReportService } from '../inservice/report.service';
import { FrmService } from '../inservice/frm.service';
import { CookieService } from '../_services/cookie.service';
import {Utils} from '../_util/utils';
import { ChangeDetectorRef, AfterContentChecked} from '@angular/core';
import { InjectDirective } from '../_directive/inject.directive';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-complete-rpt',
  templateUrl: './complete-rpt.component.html',
  styleUrls: ['./complete-rpt.component.css']
})
export class CompleteRptComponent implements OnInit {
	logoInfo=[];
	userInfo:any;
	userId:string;
	userName="User";
	r:string;
	public logOutFlag=0;
	public showLogo=0;
	reportInfo:any;
	addon:string;
	/*types=[];
	libraries=[];
	libLabels=[];
	slots=[];
	tempSlots=[];
	curSlots=[];
	rangeIndex=0;
	curLibs=[];
	itemIndex=0;
	cols1:any[];
	cols2:any[];
	cols3:any[];
	cols4:any[];
	cols5:any[];*/
	cols6:any[];
	//selectedSlot:any;
	//selectedRptType:string;
	//selectedType="";
	selectedCover={'COPIED_FROM_ID':null,'COVERPAGE_ID':null, 'COVERPAGE_TITLE':null};
	selectedHeader={'COPIED_FROM_ID':null,'HEADER_ID':null, 'HF_TITLE':null};
	selectedFooter={'COPIED_FROM_ID':null,'FOOTER_ID':null, 'HF_TITLE':null};
	selectedTHeader={'COPIED_FROM_ID':null,'TOC_HEADER_ID':null, 'HF_TITLE':null};;
	selectedTFooter={'COPIED_FROM_ID':null,'TOC_FOOTER_ID':null, 'HF_TITLE':null};;
	selectedWatermarker="";
	selectedIden="";
	tempName="";
	categories:any[];
	catForSel=[
        {label: 'Category', value: 'Category'},
        {label: 'Used Fields', value: 'Used Fields'},  
    ];
	temps:any[];
	sections:any[];
	contents:any[];	
	frontpages:any[];
	appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
	curIndex=[];
	pageIndex=[];
	public expandedRows = {};
	isExpanded=false;
	

	filteredData:any[];
	otherTypes=['TABLE','MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE'];
	curTableData:any;
	rowNo=10;
	colNo=0;
	colType=[];
	newLibPara=[];
	addedItem:any;
	addBefore=false;
	addLibWarn=false;
	selectedCell:any;
	selectedRow:number;
	inputLabels='';
	isEven=true;
	rPercentage=0;
	wPercentage=0;
	imgGroup='other';
	uploadFiles=0;
	uploadTotal=0;
	uploadNo=0;
	public current:any;
	public projects=[]
	public reports=[];
	public curReport:any;
	public bks=[];
	public others=[];
	public photos=[];
	public logos=[];
	public projectFiles=[];
	public selectedContainer;
	public selectedImage;
	public selectedInsert;
	public ckconfig:any;
	public docs=[];
	public convertDocs=[];
	public docList=[];
	public docIndex:number;
	public sectionIndex=0;
	public currentDocIndex:string;
	public srcPage='dsContainer';
	public getSecData=0;
	public startP=0;
	public outDoc:string;
	private fileReader: FileReader;
	public pageMargin={'top':'0', 'bottom':"0", 'left':"25", 'right':"25"};
	public tocMargin={'top':'0', 'bottom':"0", 'left':"25", 'right':"25"};
	public portraitSize={'width':'816','height':'1054'};
	public landscapeSize={'width':'1054','height':'816'};
	public selectpage={'type':'portrait', 'size':{'width':'816','height':'1054'}};
	public selectPdi='600';
	public selectFont="times new roman";
	public lineSpace="0";
	public content='';//'<figure class="image image_resized" style="width:22.65%;"><img src="./assets/images/logo.png"></figure>';
	public rowData;
	public outData:string;
	public savedData:any;
	public testData:any;
	public uploadType:string;
	public bimageurl='';//="https://erisservice.ecologeris.com/exreport/test/cbkimage/R2EDw0jKeL6FzQZSAQ3QoEkqRWM3dW_bk2.jpg";
	public paraIndex=0;
	showCover=false;
	slotGroup='T';
	libGroup='A';
	addLib=false;
	appOp='O';
	definedSlotGroup=[];
	definedLibGroup=[];
	loading=false;
	pdfs=[];
	tableContent=[];
	editOrder=false;
	watermarkers=[];
	erisPdfs=[];
	public currencies=[];//['USD','CAD','EUR','GBP','CHF','MXN','YEN'];
	public multipliers:any;
	public pcaOp={'term':'Include','multiplier':"",'quantity':0, 'reserve':10, 'age':0, 'decimal':2,'currency':'USD','inflation':2.5,'round':'Round'};
	public pcaLibraries=[];
	public costTables=[];
	public curCosts=[];
	public curCost:any;
	public curCostId=[];
	public addedCost=[];
	public rowItem={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'Immediate': 0,'Short': 0, 'EFF':0,'EUL':0,'RUL':0,"Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10, 'data':{'COST':[]}};
	public newRow={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'Immediate': 0,'Short': 0, 'EFF':0,'EUL':0,'RUL':0,"Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10,'data':{'COST':[]}};	
	public units=[];
	public reserveWarn=false;
	public validateWarn=false;
	public totalCost=[0,0,0,0,0,0,0,0];
	public repairData:any;
	public currSign='$';
	public savedRepair:any;
	public uploading=false;
	public addedPdfs=[];
	public clipBoard:any;
	public addedPhotos=[];
	selectedFilters:any;
	filterShow=false;
	filterData=[];
	allSlotInfo=[];
	allSlots=[]
	ifPhoto=false;
	ifAppPdf=false;
	addPdfIndex=[];
	saveTimer:any;
	start:number;
	end:number;
	gap=15000;
	history=[];
	secHistory=[];
	fileShow=false;
	filterSlot:string;
	filtering=false;
	autoFlag=false;
	fromTemplate=false;
	commIds=[];
	toprintIndex=0;
	pdfType:any;
	hideSection=true;
	selectedEditor:any;
	lpagesize="legal-landscape";
	head1:string;
	head2:string;
	head3:string;
	head1Space='1';
	head2Space='1';
	head3Space='1';
	public PropertyAsReportedHTML:any;  
	public PropertyConditionAssessmentPropertyCoreCharacteristics:any;
	public PropertyConditionAssessmentPropertyCoreCharacteristicsHTML:any;
	public PropertyConditionAssessment:any;
	public PropertyConditionAssessmentHTML:any;
	public frmData:any;
	public PropertyAmenity:any;
	public PropertyTotalRentRollSummary:any;
	public flatDataAmentities:any;
	public flatData:any;
	public flatDataSec2:any;
	public flatDataSec3:any;
	public flatDataSetSec3:any;
	public flatPartySetSec3:any
	public flatDataSec4:any;
	public flatDataSetSec4:any;
	public tableset:any;
	public sec2tablesdata:any[];
	public sec3tablesdata:any[];
	public sec6tablesdata:any[];
	public curSec:any;	
	public curCell:any;	
	public cellShow:any;
	public datasrc:boolean;	
	public bedroomList=['0BR', '1BR', '2BR', '3BR', '4BR', '5BR'];
	public bedroomStatus=['O = occupied', 'V = vacant', 'D = down','R = Other'];
	public ORrows=[];
	public repairTotal=0;
	//waterCheck=[false, false, false, false, false];
	waters=['privateWellsDrinkingWater','privateWellsNonDrinkingWater','wasteWaterTreatment', 'privateLiftStations'];
	repairtCount=[false,false,false,false,false, false];
	frmSec:any;
	errMsg='';
	noPrint=false;
	blackText=false;
	acceptType=[];
	public unitrow=1
	public sec3type1=[0,1,4,5];
	public sec3type2=[2,3]; 
	iframeSrc: SafeResourceUrl | null = null;
	iframeSrc1: SafeResourceUrl | null = null;
	private iframeBlobUrl: string | null = null;
	@ViewChild(InjectDirective) injectComp: InjectDirective;
	@ViewChild('file') file: ElementRef;
	@ViewChild('file1') file1: ElementRef;
	@ViewChild('file2') file2: ElementRef;
	@ViewChild('pdfmsg') pdfmsg: ElementRef;
	@ViewChild('pdfspin') pdfspin: ElementRef;
	@ViewChild("frmContent") frmContent: ElementRef;
	@ViewChildren("frmContent") children!: QueryList<"frmContent">;
  constructor(private location: Location,private titleService :Title, public sanitizer: DomSanitizer, private router: Router,
  public  reportService: ReportService, private zone: NgZone, private cookieService:CookieService,private route: ActivatedRoute,private cdref: ChangeDetectorRef,public frmService:FrmService) {
		router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          const element = document.querySelector("#" + tree.fragment);
          if (element) { element.scrollIntoView(); }
        }
      }
    });
	let id=decodeURI(this.route.snapshot.paramMap.get('id')); //console.log(id);
	let project=decodeURI(this.route.snapshot.paramMap.get('project')); //console.log(project);
	//this.getOrderDetail();
	if(this.cookieService.getCookie("userID")) {
						this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
						this.userId = this.cookieService.getCookie("userID");//console.log(this.userId);
						this.userName = this.cookieService.getCookie("userName");//console.log(this.userName);
						this.r=this.cookieService.getCookie("r");//console.log(this.r);
						if(id!='null'&&project!='null'){
							let startJson={"PROCEDURE":"getreportreadonly","USER_ID":this.userId,"REPORT_ID":id}
							this.reportService.univeralService(JSON.stringify(startJson)).subscribe(response => {
								//console.log(response);
								if(response.RESPONSE_STATUS=='Y'){
									if(response.READ_ONLY=='Y'){
										if(response.ERROR_MESSAGE&&response.ERROR_MESSAGE.length>0){
											$('#overlay').css('display', 'none');
											Swal.fire({
												icon:'info',
												title: response.ERROR_MESSAGE,
												text:"Please close this browser tab to return to your dashboard.",
												showCancelButton: false,
												showConfirmButton: false, 
												backdrop:true,
												//showConfirmButton: false, //hide OK button
												allowOutsideClick: false,
											})
										}else{
											this.getRpt(id);
											//this.getReports(project, parseInt(this.userId));
											//this.getProjectFiles(parseInt(project),parseInt(this.userId));
											//this.getAllFooter(parseInt(this.userId));
											//this.getAllBk(parseInt(this.userId), parseInt(project));
											//this.getLogo();
											this.getCommId(id);
											this.getAllSlots(id);
										}
										
						
									}else{
										this.router.navigate(['report/'+project+'/'+id])
											.then(nav => {
												//console.log(nav); // true if navigation is successful
											}, err => {
												console.log(err) // when there's an error
											});
									}
								}else{
									this.throwError(response);
								}
							})
						
							
														
						}
						
					
						
						
	} 
	
		this.acceptType=this.reportService.acceptFileType.split(',');
	  }
	getOrderDetail(){
		if(this.cookieService.getCookie("userID")) {
						this.userId = this.cookieService.getCookie("userID");//console.log(this.userId);
						this.userName = this.cookieService.getCookie("userName");//console.log(this.userName);
						this.r=this.cookieService.getCookie("r");//console.log(this.r);
						//this.getAllCover(parseInt(this.userId));
					
		} else {
			this.userId=null;			
		}
	}
	getAllSlots(id){
		let tempJson={"PROCEDURE":"getslotsbyreportnocategory", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		//console.log(tempJson);
		this.reportService.univeralService(JSON.stringify(tempJson)).subscribe(response => {
			//console.log('slots',response);//templateSlots
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return										
			}
			this.allSlots=response.RW_SLOTS; //console.log(this.allSlots);
			
		})
	}

	
	
	
	
	getProjectFiles(pid, uid){
		let inputJson= {"PROCEDURE":"getfilesbyproject","USER_ID":uid,"PROJECT_ID":pid};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.projectFiles=data.RW_UPLOAD_FILES;
		})
	}

  ngOnInit(): void {
	this.titleService.setTitle("Complete Report");
	  if(this.reportService.autoSaveFlag=='Y'){
		  this.autoFlag=true;
	  }
		let w = Math.floor(Utils.mmToPx(279, this.reportService.dpi));// console.log(w);
		let h = Math.floor(Utils.mmToPx(216, this.reportService.dpi)); //console.log(h); 
	  	
		this.cols6 = [			
			//{ field: 'SLOT_ID', header: 'Id' },
         	{ field: 'FILE_NAME', header: 'File Name', width: '40%' },
			{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
			{ field: 'PROJECT_NUMBER', header: 'Project Name', width: '15%' },
			{ field: 'REPORT_CATEGORY', header: 'Report Type ' , width: '14%' },
			{ field: 'UPDATED_BY', header: 'Upload By ' , width: '12%' },
			{ field: 'DATE_UPDATED', header: 'Date ' , width: '8%' },
				
        ];
		let id=decodeURI(this.route.snapshot.paramMap.get('id')); //console.log(id);
		let project=decodeURI(this.route.snapshot.paramMap.get('project')); //console.log(project);
		$(document).ready(function () {
			//$('#tableModal').draggable();	
			$('#fileModal').draggable();
			//$('#costDetailModal').draggable();
			$('#costZoomModal').draggable();
			//$('#historyModal').draggable();	
		});  
	 
	 
  }	
  ngAfterViewInit() {
	this.children.changes.subscribe(() => {
		if (this.reportInfo && (this.reportInfo.PCA_INDICATOR == 'frm1104'||this.reportInfo?.PHASE1_TYPE=='1103')) {
			// build blob and keep raw URL for revoke, pass a SafeResourceUrl to template
			const blob = new Blob([this.getFrmHtml()], { type: 'text/html' });
			this.iframeBlobUrl = URL.createObjectURL(blob);
			this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeBlobUrl);
		}else if(this.reportInfo && this.reportInfo.PCA_INDICATOR == 'frm1105'){
			// build blob and keep raw URL for revoke, pass a SafeResourceUrl to template
			const blob = new Blob([this.getFrmHtml()], { type: 'text/html' });
			this.iframeBlobUrl = URL.createObjectURL(blob);
			this.iframeSrc1 = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeBlobUrl);
		}
	});
	}
	ngOnDestroy() {
		// revoke the raw blob URL only
		if (this.iframeBlobUrl) {
			URL.revokeObjectURL(this.iframeBlobUrl);
			this.iframeBlobUrl = null;
		}
	}
	ngAfterContentChecked() {

    this.cdref.detectChanges();

  }
	public onInfo(e){
	  this.getOrderDetail();
	}
	onSavedLogo(e){
		
		this.showLogo = e;
    
	}
	onEditReport(e){
		
	} 
	logOut(){
		this.logOutFlag++; //console.log(this.logOutFlag);
	}
	
	getAllBk(id, pid){
	
		let inputJson2={"PROCEDURE":"getprojectphotos","USER_ID":id,"PROJECT_ID":pid}
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.photos=data.RW_UPLOAD_FILES;
		})
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"BKIMAGE"}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.bks=data.RW_UPLOAD_FILES;
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":id,"FILE_TYPE":"IMAGE"}
		//console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.others=data.RW_UPLOAD_FILES;
		})
	} 
	private getLogo(){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"LOGO"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.logoInfo=data;		
			this.logos=data.RW_UPLOAD_FILES;
		})
 
	}
	
 private locations(substring,string){
  var a=[],i=-1;
  while((i=string.indexOf(substring,i+1)) >= 0) a.push(i);
  return a;
}
	public preview(type?, id?){
		this.toprintIndex++;
		this.pdfType={'index':this.toprintIndex, 'type':type};
		
		
	}
	
	public upload(type?) {//console.log(type)
	
		if(type){
			this.uploadType=type;
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			this.file.nativeElement.click();
		}else if(this.uploadType=='FILE'){
			this.appOp='U';
			this.file1.nativeElement.click();
		}
	}

	public uploadImage() {
	this.uploading=true;
	let that=this;
	this.uploadFiles=0;
		this.uploadNo=0;
 
	const files = this.file.nativeElement.files; //console.log(files);
 
	 if(files.length==0){
		this.loading=false;
      return
    }
	const total=files.length;
		this.uploadNo=total;
	 for(let i=0; i<files.length; i++){//console.log(files[0]);
		const ext = files[i].name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.loading=false;
			return;
		}
    }
  
	for (let file of files)
    {   
		
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
					
			if(that.uploadType=='BKIMAGE'){//console.log('bk image');
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);	
					that.uploading=false;	
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++	
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
						
			})
			}else if(that.uploadType=='PHOTO'){//console.log('report image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
								
			})
			}else if(that.uploadType=='IMAGE'){//console.log('other image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='LOGO'){//console.log('LOGO image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
			})
			}
			//console.log(inputJson)
		
			
		}
		reader.readAsDataURL(file);
		}
  }
  
	uploadFile(){
		this.uploading=true;
		let that=this;
		this.uploadFiles=0;
		this.uploadNo=0;
		const files = this.file1.nativeElement.files;// console.log(files);
		if(files.length==0){
			this.loading=false;
		return
		}
		for (let file of files){  //for multiple files
			const ext = file.name.replace(/.+\./, '');
		   if (this.acceptType.indexOf(ext) === -1) {
			   Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			   this.loading=false;
			   return;
		   }
	   }
		const total=files.length;
		this.uploadNo=total;
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.uploading=false;
						that.throwError(result);
						//console.log(result.ERRORCODE)
					}else{
						that.projectFiles.push(result);
						that.uploadFiles++
						that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
						that.uploading=false;
					}					
				})		
			//console.log(inputJson)
			
			
		}
		reader.readAsDataURL(file);
		} 
  }

	toImage(e){//console.log($(event.target));
		if($(event.target)[0].tagName=="IMG"){
			$('#imgModal').modal('show');
			this.selectedContainer=$(event.target)[0];
			this.selectedImage=null;
		}
	}
	public insertImage(){
		if(this.savedData){
			$('#insertModal').modal('show');
		}
	}
	
	public chooseBackground(){
		if(this.savedData){
		$('#bkModal').modal('show');
	
		}
	}
	public selectBK(bk){
		this.bimageurl=bk;
		this.savedData.bk=bk;
		
	}
	public selectPage(type){
		let page:any;
		if(type=='portrait'){
			page=this.portraitSize;
		}else if(type=='landscape'){
			page=this.landscapeSize;
		}
		this.selectpage={'type':type, 'size':page};//console.log(this.selectpage)
	}
	toggleChild(e){
		e.stopPropagation();
		let child=$(e.target).parents('a').next('div');//console.log(child);
		child.toggle();
		if(child.css('display')=='flex'){
			$(e.target).removeClass('fa-angle-down');
			$(e.target).addClass('fa-angle-right');
		}else{
			$(e.target).removeClass('fa-angle-right');
			$(e.target).addClass('fa-angle-down');
		}
	}
	listid:string;
	getFListPosition(id, e,i?,j?){
		if(e && e.stopPropagation){
			e.stopPropagation();
		}
		this.listid=id;
		this.selectedEditor='F';
		this.curIndex=[];
		let status=$(e.target).hasClass('active');// console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.pageIndex=[i,j];			
			this.scroll(id+'content');			
		}	
		this.addLib=false;
		
	}
	getListPosition(id, e,i?,j?,k?){//console.log(e,i,j,k)
		if(e && e.stopPropagation){
			e.stopPropagation();
		}
		this.listid=id;
		this.selectedEditor='O';
		let status=$(e.target).hasClass('active');// console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.curIndex=[i,j,k];//console.log(this.curIndex);
			let posi=id;

			//console.log(posi);
			this.scroll(posi+'content');
			
		}

		this.addLib=false;
		//console.log(this.curIndex[1]);
	}
	getPosition(id, e,i?,j?,k?){//console.log(e,i,j,k)
	let status=$(e.target).hasClass('active'); //console.log(status)
	this.listid=id;
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			
			let posi=id;
			if(k>-1){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','block');
				})
			}else if(j>-1){
				k=this.addon;
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(i>-1){
				k=this.addon;
				j=this.addon;
			
			}
	
			this.scrollPanel(posi+'list');
			this.curIndex=[i,j,k];//console.log(this.curIndex);
		}
	
		this.addLib=false;
		//console.log(this.curIndex);
	}
	scroll(id) {
	
		let el = document.getElementById(id);//console.log(el);
		if(el){
			el.scrollIntoView({block: "center", inline: "nearest"});
		}
	}
	scrollPanel(id) {
		
		let el = document.getElementById(id);//console.log(el);
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	scrollTo(id, index){//console.log(id)
			if(index[2]&&index[2]>-1){				
			}else if(index[1]&&index[1]>-1){
				index[2]=this.addon;
				
			}else if(index[0]>-1){
				index[1]=this.addon;
				index[2]=this.addon;
				
			}
		this.curIndex=index;//console.log(this.curIndex);
		let posi=id;
		//console.log(posi);
		this.scroll(posi+'content');
	}
	expandToggle(e){
		let level=$(e.target).prev('select').val();
		if(!$(e.target).hasClass('active')){
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','block');
				})
			}
			$(e.target).addClass('active');
			$(e.target).text('Collapse');
		}else{
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','none');
				})
			}
			$(e.target).removeClass('active');
			$(e.target).text('Expand');
		}
		
	}
	
	
  getRpt(id){//console.log(id);
		$('#overlay').css('display','block');
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};// Optional Version_ID - select most recent version if version_id is null
		//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('reportdata',data);
			if(data.ERRORCODE){
				this.throwError(data)
			}
			this.curReport=data;
			if((data.REPORT_DATA&&data.REPORT_DATA.length>0)||(data.BEFORE_TOC&&data.BEFORE_TOC.length>0)){
				this.contents=JSON.parse(data.REPORT_DATA); //console.log('content',this.contents);
				let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
					//console.log('report',response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
						return										
					}
					this.reportInfo=response;
					if(response.REPORT_PDF_SETTING){
						let setInfo=JSON.parse(response.REPORT_PDF_SETTING);// console.log(setInfo)
						if(setInfo.pagesize){
							this.lpagesize=setInfo.pagesize;
						}
						if(setInfo.margin){
							this.pageMargin=setInfo.margin;
						}
						if(setInfo.orientation){
							this.selectpage=setInfo.orientation;
						}
					}
					if(response.PCA_PAGE_SETUP){
						this.lpagesize=response.PCA_PAGE_SETUP;
					}
					this.iniFrmdata();
					if(response.HEADING1_DESIGN&&response.HEADING1_DESIGN.length>0){
							this.head1=response.HEADING1_DESIGN; //console.log(this.head1);
						}
						if(response.HEADING2_DESIGN&&response.HEADING2_DESIGN.length>0){
							this.head2=response.HEADING2_DESIGN;//console.log(this.head2);
						}
						if(response.HEADING3_DESIGN&&response.HEADING3_DESIGN.length>0){
							this.head3=response.HEADING3_DESIGN;//console.log(this.head3);
						}
						if(response.HEADING1_SPACING&&response.HEADING1_SPACING.length>0){
							this.head1Space=response.HEADING1_SPACING; //console.log(this.head1Space);
						}
						if(response.HEADING2_SPACING&&response.HEADING2_SPACING.length>0){
							this.head2Space=response.HEADING2_SPACING
						}
						if(response.HEADING3_SPACING&&response.HEADING3_SPACING.length>0){
							this.head3Space=response.HEADING3_SPACING
						}					
					if(response.COVERPAGE&&response.COVERPAGE.length>0){
						this.selectedCover=response.COVERPAGE[0];
					}
					if(response.HEADER&&response.HEADER.length>0){
						this.selectedHeader=response.HEADER[0];
					}
					if(response.FOOTER&&response.FOOTER.length>0){
						this.selectedFooter=response.FOOTER[0];
					}
					if(response.TOC_HEADER&&response.TOC_HEADER.length>0){
						this.selectedTHeader=response.TOC_HEADER[0];						
					}
					if(response.TOC_FOOTER&&response.TOC_FOOTER.length>0){
						this.selectedTFooter=response.TOC_FOOTER[0];						
					}
					if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
						this.frontpages=JSON.parse(data.BEFORE_TOC); //console.log('front', this.frontpages)
					}
					this.pageMargin.top=response.REPORT_MARGIN_TOP;
					this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
					this.pageMargin.left=response.REPORT_MARGIN_LEFT;
					this.pageMargin.right=response.REPORT_MARGIN_RIGHT;
					this.tocMargin.top=response.TOC_MARGIN_TOP;
					this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
					this.tocMargin.left=response.TOC_MARGIN_LEFT;
					this.tocMargin.right=response.TOC_MARGIN_RIGHT;	
					if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
						this.blackText=true;
					}else{
						this.blackText=false;
					}
					if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
						let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};
						this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result=>{
							//console.log(result);
							if (result.RESPONSE_STATUS=='N') {
								this.throwError(result)
								return										
							}
							this.pdfs=result.REPORT_LINKS;	
							this.updatePdfs();							
						})
						let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};console.log(inputJson6);
						this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
							//console.log(result);
							if (result.RESPONSE_STATUS=='N') {
								this.throwError(result)
								return										
							}
							this.erisPdfs=result.PRODUCT_LINKS;
						})
					}
					this.titleService.setTitle("Complete Report"+' - '+this.reportInfo.REPORT_TITLE);
					if(!this.reportInfo.PERCENT_COMPLETE||this.reportInfo.PERCENT_COMPLETE.length==0){
						this.wPercentage=0;
					}else{
					this.wPercentage=parseFloat(this.reportInfo.PERCENT_COMPLETE);
					}
					if(!this.reportInfo.REVIEWER_PROGRESS||this.reportInfo.REVIEWER_PROGRESS.length==0){
						this.rPercentage=0;
					}else{
						this.rPercentage=parseFloat(this.reportInfo.REVIEWER_PROGRESS);
					}
					
					this.location.go('/complete-rpt/'+this.reportInfo.PROJECT_ID.toString()+'/'+id.toString());
					$('#overlay').css('display','none');
				})
				
				//Update the URL 
				let inputJson4= {"PROCEDURE":"getreportappendix","USER_ID":parseInt(this.userId),"REPORT_ID":id};
		//console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson4)).subscribe(response => {
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return										
			}
			if(response.APPENDIX_DATA&&response.APPENDIX_DATA.length>0){
				this.appendices=JSON.parse(response.APPENDIX_DATA);//console.log(this.appendices);
				this.updatePdfs();	
			}
		})
				
			}else{
				let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
					//console.log('report', response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
						return										
					}
					this.reportInfo=response;
					if(response.REPORT_PDF_SETTING){
						let setInfo=JSON.parse(response.REPORT_PDF_SETTING); //console.log(setInfo)
						if(setInfo.pagesize){
							this.lpagesize=setInfo.pagesize;
						}
						if(setInfo.margin){
							this.pageMargin=setInfo.margin;
						}
						if(setInfo.orientation){
							this.selectpage=setInfo.orientation;
						}
						
						
						
						//this.bimageurl=setInfo.bk;
					}
					if(response.HEADING1_DESIGN&&response.HEADING1_DESIGN.length>0){
							this.head1=response.HEADING1_DESIGN; //console.log(this.head1);
						}
						if(response.HEADING2_DESIGN&&response.HEADING2_DESIGN.length>0){
							this.head2=response.HEADING2_DESIGN;//console.log(this.head2);
						}
						if(response.HEADING3_DESIGN&&response.HEADING3_DESIGN.length>0){
							this.head3=response.HEADING3_DESIGN;//console.log(this.head3);
						}
						if(response.HEADING1_SPACING&&response.HEADING1_SPACING.length>0){
							this.head1Space=response.HEADING1_SPACING; //console.log(this.head1Space);
						}
						if(response.HEADING2_SPACING&&response.HEADING2_SPACING.length>0){
							this.head2Space=response.HEADING2_SPACING
						}
						if(response.HEADING3_SPACING&&response.HEADING3_SPACING.length>0){
							this.head3Space=response.HEADING3_SPACING
						}
						this.pageMargin.top=response.REPORT_MARGIN_TOP;
						this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
						this.pageMargin.left=response.REPORT_MARGIN_LEFT;
						this.pageMargin.right=response.REPORT_MARGIN_RIGHT;
						this.tocMargin.top=response.TOC_MARGIN_TOP;
						this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
						this.tocMargin.left=response.TOC_MARGIN_LEFT;
						this.tocMargin.right=response.TOC_MARGIN_RIGHT;	
					if(response.COVERPAGE&&response.COVERPAGE.length>0){
						this.selectedCover=response.COVERPAGE[0];
					}
					if(response.HEADER&&response.HEADER.length>0){
						this.selectedHeader=response.HEADER[0];
					}
					if(response.FOOTER&&response.FOOTER.length>0){
						this.selectedFooter=response.FOOTER[0];
					}
					if(response.TOC_HEADER&&response.TOC_HEADER.length>0){
						this.selectedTHeader=response.TOC_HEADER[0];						
					}
					if(response.TOC_FOOTER&&response.TOC_FOOTER.length>0){
						this.selectedTFooter=response.TOC_FOOTER[0];						
					}
					if(response.WATERMARK&&response.WATERMARK.length>0){
						this.selectedWatermarker=response.WATERMARK[0].WATERMARK_ID;
					}
					if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
						this.frontpages=JSON.parse(data.BEFORE_TOC); //console.log('front', this.frontpages)
					}	
					if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
						this.blackText=true;
					}else{
						this.blackText=false;
					}				
					if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
						let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM}
						this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result=>{
							//console.log(result);
							if (result.RESPONSE_STATUS=='N') {
								this.throwError(result)
								return										
							}
							this.pdfs=result.REPORT_LINKS;
							this.updatePdfs();							
						})
						let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};console.log(inputJson6);
						this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
							//console.log(result);
							if (result.RESPONSE_STATUS=='N') {
								this.throwError(result)
								return										
							}
							this.erisPdfs=result.PRODUCT_LINKS;
						})
					}
					this.titleService.setTitle("Complete Report"+' - '+this.reportInfo.REPORT_TITLE);
					if(this.reportInfo.PERCENT_COMPLETE&&this.reportInfo.PERCENT_COMPLETE.length==0){
						this.wPercentage=0;
					}else{
						this.wPercentage=parseFloat(this.reportInfo.PERCENT_COMPLETE);
					}
					if(this.reportInfo.REVIEWER_PROGRESS&&this.reportInfo.REVIEWER_PROGRESS.length==0){
						this.rPercentage=0;
					}else{
						this.rPercentage=parseFloat(this.reportInfo.REVIEWER_PROGRESS);
					}
					//Update the URL 
				this.location.go('/complete-rpt/'+this.reportInfo.PROJECT_ID.toString()+'/'+id.toString());
				$('#overlay').css('display','none');	
				})
				
			}
			this.curIndex=[this.addon,this.addon,this.addon];
			
		})
		
	}
	
	getOrderPdf(e){
		let no=$(e.target).siblings('input[type="text"]').val().trim();//console.log(this.curReport);
		let inputJson={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":no};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
				//console.log(result);
				if (result.RESPONSE_STATUS=='N') {
					this.throwError(result)
					return										
				}
				this.pdfs=result.REPORT_LINKS;
				this.updatePdfs();
				let inputJson1={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"ORDER_NUM":no};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response=>{
					//console.log(response);
				})
		})
		let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":no};//console.log(inputJson6);
						this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
							//console.log(result);
							if (result.RESPONSE_STATUS=='N') {
								this.throwError(result)
								return										
							}
							this.erisPdfs=result.PRODUCT_LINKS;							
						})	
	}
	deleteFile(item, type){
		//console.log(item)
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					//console.log(JSON.parse(response))
					if(JSON.parse(response).STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.projectFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID); console.log(index);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}else{
						this.throwError(JSON.parse(response))
					}
				})
			}
		})
	}
	updateFile(item, type, e? ){//console.log(item);
		let data=$(e.target).prev('textarea').val();//console.log(data);
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		//console.log(inputJson);
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response)
			let file=JSON.parse(response);
			if (file.RESPONSE_STATUS=='N') {
				this.throwError(file)
				return										
			}
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		})
	}
	
	
	
	tableZoom(data){
		//console.log(data)
		$("#costZoomModal").modal('show');
		this.repairData=data;
	}
	
	
	updatePdfs(){console.log(this.appendices);
		//console.log(this.pdfs)
		if(this.pdfs&&this.pdfs.length>0){
		for(let item of this.appendices.SUB_SECTIONS){
			if(item.app&&item.app.length>0){
			for(let rf of item.app){//console.log(rf)
				if(!rf.url||rf.url.length==0){
					let name=rf.name;//console.log()
					let index=this.pdfs.findIndex(slot=>slot.REPORT_NAME==name);
					if(index>-1){
						rf['url']=this.pdfs[index].REPORT_URL;
					}else{
						//rf.selectedfile=false;
					}
				}
			}
		}
		}
		}
		//console.log(this.appendices)
		
	}
	changeDesc(index, e, index1?, index2?, index3?){//console.log(e);
		this.selectedRow=-1;
		let datas=this.contents;		
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].photos[index].FILE_DESCRIPTION=e;
		}else if(index2>-1){
			datas[index1].SUB_SECTIONS[index2].photos[index].FILE_DESCRIPTION=e;
		}else{
			datas[index1].photos[index].FILE_DESCRIPTION=e;
		}
		this.curIndex=[index1, index2, index3];//console.log(this.curIndex)
	}
	opPrjFile(){
		this.getProjectFiles(this.reportInfo.PROJECT_ID,parseInt(this.userId));
		this.getAllBk(parseInt(this.userId),this.reportInfo.PROJECT_ID);
		this.getLogo();
		this.ifPhoto=false; 
		this.ifAppPdf=false; 
		this.uploadType="FILE";
		//$('#fileModal').modal('show');
		this.fileShow=true;
		$('.nav-tabs a[href="#files"]').tab('show'); 
	}
	
	
	trackByFuntion(index, item) {
		return index;
	}
	
	secComments=[];
	secComment='';
	secCommId=-1;
	reComment(id){
		//console.log('comment',this.secComment);
		let inputJson={"PROCEDURE":"savesectioncomment","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_ID":id,"COMMENT_CONTENT":this.secComment,"COMMENT_STATUS":"New"};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);	
			if(data.RESPONSE_STATUS=='Y'){
				this.secComments=data.RW_COMMENTS;
				this.secComment='';
				this.commIds.push(id)
			
			}else{
				this.throwError(data);
				}
		})
	}
	updateStatus(id){
		let inputJson={"PROCEDURE":"updatecommentstatus","USER_ID":parseInt(this.userId),"COMMENT_ID":id,"COMMENT_STATUS":"Resolved"}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=="Y"){			
				let index=this.secComments.findIndex(comm=>comm.COMMENT_ID==id);
				if(index>-1){
					this.secComments[index].COMMENT_STATUS='Resolved';
				}
			}else{
				this.throwError(data);
				}
			
		})
	}
	getSecComments(doc, id){//console.log(doc);
		let inputJson={"PROCEDURE":"getcommentsbysection","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				this.secComments=data.RW_COMMENTS;
				this.secComment='';
			}else{
				this.throwError(data);
				}			
		})
	}
	getCommId(id){
		let inputJson={"PROCEDURE":"getreportsectionswithcomments","USER_ID":parseInt(this.userId),"REPORT_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				this.commIds=[];
				let comms=data.SECTION_LIST;
				for(let comm of data.SECTION_LIST){
					this.commIds.push(comm.SECTION_ID)
				}
				//console.log(this.commIds) 
				
			}else{
				this.throwError(data);
				}			
		})
	}
	sideNavWidth = '60px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '60px'
			this.toggleSideBarVar = false
		}
	}
	saveMargin(type?){
		let margin={
				"TOC_MARGIN_TOP":this.tocMargin.top.toString(),
				"TOC_MARGIN_BOTTOM":this.tocMargin.bottom.toString(),
				"TOC_MARGIN_LEFT":this.tocMargin.left.toString(),
				"TOC_MARGIN_RIGHT":this.tocMargin.right.toString(),
				"REPORT_MARGIN_TOP":this.pageMargin.top.toString(),
				"REPORT_MARGIN_BOTTOM":this.pageMargin.bottom.toString(),
				"REPORT_MARGIN_LEFT":this.pageMargin.left.toString(),
				"REPORT_MARGIN_RIGHT":this.pageMargin.right.toString(),
			
		}
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,...margin};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				this.reportInfo=data;
				$('#marginModal').modal('hide');
			}else{
				this.throwError(data)
			}
		});
		
	}
	setToc(e){
		let val=e.target.value;
		let	inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"TOC_IND":val};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=="Y"){
					this.reportInfo=data;
				}else{
					this.throwError(data);
				}
			})		
	}
	pdfSpin(e){
		if(e=='start'){
			this.pdfspin.nativeElement.style.display='inline-block';
			this.noPrint=true;
		}else{
			this.pdfspin.nativeElement.style.display='none'
			this.noPrint=false;
		}
	}
	
	showErrMsg(e){
		this.errMsg=e;
	}
	saveBlack(){
		let printblack='N'
		if(this.blackText){
			printblack='Y';
		}
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"PRINT_BLACKWHITE":printblack};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{			
			if(result.RESPONSE_STATUS!="Y"){
				this.throwError(result);
			}		
		})
	}
	openHFPage(id){
		let inputJson={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);					
			}else{console.log(data)
				if(data.HF_DATA&&data.HF_DATA.length>0){
					let htData=JSON.parse(data.HF_DATA);
					if(htData.inputType&&htData.inputType=='HTML'){
						let dataInput=htData.inputType;
 						let savedHTML=this.sanitizer.bypassSecurityTrustHtml(htData.text); 
					
					//this.titleService.setTitle("Footer"+' - ');
					//this.location.go('/cover/Footer-'+data.HEADERFOOTER_ID.toString());
					let newWin = window.open('',data.HF_TITLE);
					newWin.document.write(htData.text);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
				}				
			}
		})		
	}
	openCoverPage(id){
		let inputJson={"PROCEDURE":"getcoverpage", "USER_ID":parseInt(this.userId), "COVERPAGE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);					
			}else{console.log(response)
				let data=JSON.parse(response.COVERPAGE_DATA);
				if(data.html&&data.html.length>0){
					let newWin = window.open('',response.HF_TITLE);
					newWin.document.write(data.html);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
			}			
		})		
	}
	USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});
	USDollar1 = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0, 
  		minimumFractionDigits: 0,
	});
	getFrmHtml(){
		let html:string='';
		html=this.frmService.pdfHead;
		html+=this.frmContent.nativeElement.innerHTML;
		html+='</main></body></html>';//console.log(html)
		return html;
	}
	iniFrmdata(){
		if(this.reportInfo&&this.reportInfo.PCA_INDICATOR=='frm1104'){
			if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length==0){
				this.unitrow=1
			}else{
				this.unitrow=Math.ceil(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length/4);      
			}
			return
		}else if(this.reportInfo&&this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=='1103'){
			if(this.contents[2].SUB_SECTIONS[0].data.units.length==0){
				this.unitrow=5;
				for(let i=0; i<20; i++){
					this.contents[2].SUB_SECTIONS[0].data.units.push("");
				} 
			}else{
				this.unitrow=Math.ceil(this.contents[2].SUB_SECTIONS[0].data.units.length/4);  
			
			}
			return
		}
		for(let sec of this.contents){
							if(sec.TYPE=='1105'&&(sec.id='frm_sec')){
								this.frmSec=sec;
								sec['searchstring']=sec.id+Utils.uniqueIdGenerator();
								this.frmData = JSON.parse(JSON.stringify(sec.frmData));			
								//if(this.frmData['AccountNameHTML']){
								//this.AccountNameHTML=this.frmData['AccountNameHTML'];
								//}
								if(!this.frmData['sec4OutPutData']){
									this.frmData['sec4OutPutData']=[0, '$0'];
								}
								if(this.frmData['repairtCount']){
									this.repairtCount=this.frmData['repairtCount'];
								}
								if(this.frmData['flatPartySetSec3']){
									this.flatPartySetSec3=this.frmData['flatPartySetSec3'];
								  }
								 if(this.frmData['repairtCount']){
								   this.repairtCount= this.frmData['repairtCount'];
								  }
								if(this.frmData['sec2tablesdata']){
								this.sec2tablesdata=this.frmData['sec2tablesdata'];
								}else{
								this.frmData['sec2tablesdata']=this.sec2tablesdata;
								}
								if(this.frmData['sec3tablesdata']){
								this.sec3tablesdata=this.frmData['sec3tablesdata'];
								}else{
								this.frmData['sec3tablesdata']=this.sec3tablesdata;
								}
								if(this.frmData['sec6tablesdata']){
								this.sec6tablesdata=this.frmData['sec6tablesdata'];
								}else{
								this.frmData['sec6tablesdata']=this.sec6tablesdata;
								}
								if(this.frmData['ORrows']){
									this.ORrows=this.frmData['ORrows'];
								}
								
								this.PropertyAsReportedHTML=this.frmData.PropertyAsReportedHTML;
								this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
								this.PropertyConditionAssessmentHTML=this.frmData.PropertyConditionAssessmentHTML;
								this.toSanitizer();
								this.PropertyAmenity=this.frmData.PropertyAmenity;
								//this.PropertyAsReported=this.frmData.PropertyAsReported;
								this.PropertyConditionAssessmentPropertyCoreCharacteristics=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics;
								this.toFlat(this.frmData.PropertyConditionAssessment[0]);
								this.PropertyConditionAssessment=this.frmData.PropertyConditionAssessment;
								
								let fields=['AtInpectionWeatherDescription','PrelimInspectionDate','FinalAsmntDate','FirmAddressLineText','FirmCityName','FirmName','FirmPostalCode','FirmStateUspsCode','InspectorName','InspectorPhoneNumber','InspectorTitle','OnsiteContactName','OnsiteContactPhoneNumber',];
								//let fields=['AtInpectionWeatherDescription','FirmAddressLineText','FirmCityName','FirmName','FirmPostalCode','FirmStateUspsCode','InspectorName','InspectorPhoneNumber','InspectorTitle','OnsiteContactName','OnsiteContactPhoneNumber',];
								
								for(let field of fields){
									if(!(field=="PrelimInspectionDate"||field=="FinalAsmntDate")&&this.PropertyConditionAssessmentHTML[field]&&this.PropertyConditionAssessmentHTML[field].html.length>0){
										if($(this.PropertyConditionAssessmentHTML[field].html).find('.placeholder').length>0){
											this.PropertyConditionAssessment[0][field]=$(this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>',''))[0].innerHTML;	
										}else{
											this.PropertyConditionAssessment[0][field]=this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>','');
										}
										//this.PropertyConditionAssessment[0][field]=$(this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>',''))[0].innerHTML;
									}else if(field=="PrelimInspectionDate"||field=="FinalAsmntDate") {
										this.PropertyConditionAssessment[0][field]=this.PropertyConditionAssessmentHTML[field];
									}
								}
								this.PropertyTotalRentRollSummary=this.frmData.PropertyTotalRentRollSummary;
								
								if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length==0){
								this.unitrow=1
								}else{
									this.unitrow=Math.ceil(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length/4);      
								}
							}
						}		
	}
	resizeIframe(event: Event) {
		const iframe = event.target as HTMLIFrameElement;
		const doc = iframe.contentDocument || iframe.contentWindow?.document;

		if (!doc) return;

		iframe.style.height = doc.documentElement.scrollHeight + 60 +'px';
	}
	toFlat(alldata){
		this.flatDataAmentities=[];
		for(let data of this.PropertyAmenity){
		  this.flatDataAmentities.push(data.AmenityType);
		}
		
		this.flatData=[];
		for(let data of alldata.PropertyConditionAssessmentBuildingAndMaterials){
		   if(data.CatSubtype){
			  let text=data.CatType+';'+data.CatSubtype+';'+data.ItemType;
			  this.flatData.push(text);
			}else{
			  let text=data.CatType+';'+data.ItemType
			  this.flatData.push(text);
			}    
		}
	   // console.log(this.flatData);
		this.flatDataSec3={};
		this.flatDataSetSec3={};//console.log(alldata.PropertyConditionAssessmentWaterTreatment)
		for(let i=0; i<this.waters.length; i++){
			//if(i==1){
			//   let item={"PptyWaterSystemType": "privateWellsNonDrinkingWater",
			//	"WaterSystemOperationsDescription": ""};
			//	this.flatDataSec3[this.waters[i]]=['privateWellsNonDrinkingWater'];
			//	this.flatDataSetSec3[this.waters[i]]=[item];               
			//}else{
			  this.flatDataSec3[this.waters[i]]=[];
			  this.flatDataSetSec3[this.waters[i]]=[]; 
			//}      
		  }
		if(alldata.PropertyConditionAssessmentWaterTreatment.length>0){
		for(let data of alldata.PropertyConditionAssessmentWaterTreatment){//console.log(data)
		  if(this.flatDataSec3[data.PptyWaterSystemType]){
			if(data.WaterSystemMaintenanceResponsiblePartyType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemMaintenanceResponsiblePartyType);
			}else if(data.PptyWaterSystemSubType){
				this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
			  }else if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSec3[data.PptyWaterSystemType][0]=data.PptyWaterSystemType;
			}else{
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
			  
			}
			if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSetSec3[data.PptyWaterSystemType][0]=data;
			}else{
				this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
			} 
			
		  }else{
			this.flatDataSec3[data.PptyWaterSystemType]=[];
			this.flatDataSetSec3[data.PptyWaterSystemType]=[];
			this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
			if(data.WaterSystemMaintenanceResponsiblePartyType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemMaintenanceResponsiblePartyType);
			}else if(data.PptyWaterSystemSubType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
			}else if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSec3[data.PptyWaterSystemType][0]=data.PptyWaterSystemType;
			}else{
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
			  
			}
		  }
		 /* for(let i=0; i<this.waters.length; i++){
			if(this.flatDataSec3[this.waters[i]]&&this.flatDataSec3[this.waters[i]].length>0){
			  this.waterCheck[i]=true;
			}else if(this.flatPartySetSec3[this.waters[i]]){
				this.flatDataSec3[this.waters[i]]=[];
				this.flatDataSetSec3[this.waters[i]]=[];
				this.waterCheck[i]=true;
			  }else{
			  this.waterCheck[i]=false;
			}
		  }*/
		}
	}

		this.flatDataSec4={};
		this.flatDataSetSec4={};
		if(alldata.PropertyConditionAssessmentManufacturedHousing.length>0){
			for(let data of alldata.PropertyConditionAssessmentManufacturedHousing){
				if(this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]){
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
				}else{
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
					
				  
				}
			  }
		}else{
			this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
			this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
		}
		
		if(alldata.ManufacturedHousingUtility.length>0){
			for(let data of alldata.ManufacturedHousingUtility){
			if(this.flatDataSec4['ManufacturedHousingUtility']){
				this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);
				this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
			}else{
				this.flatDataSec4['ManufacturedHousingUtility']=[];
				this.flatDataSetSec4['ManufacturedHousingUtility']=[];
				this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
				this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);		
			}
			}
		}else{
			this.flatDataSec4['ManufacturedHousingUtility']=[];
			this.flatDataSetSec4['ManufacturedHousingUtility']=[];
		}
		
		//console.log(this.flatDataSec4);
		//console.log(this.flatDataSetSec4);
	
	  }
	toSanitizer(){
		if(this.PropertyAsReportedHTML){
		  let items=[this.PropertyAsReportedHTML,this.PropertyConditionAssessmentHTML, this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML];
		  for(let item of items){
			let keys=Object.keys(item);
			for(let key of keys){
			  if(!item[key].secHtml&&item[key].html){
				item[key].secHtml=this.sanitizer.bypassSecurityTrustHtml(item[key].html);
			  }
			}
			
		  }
		  
		}
	
	  }
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
}
